// @flow
import {type AxiosPromise} from 'axios';
import {createActions, handleActions, type ReduxReducer} from 'redux-actions';

import {sessionStore} from 'libs/storage/storage';
import type {ActionType} from 'constants/flow/flowTypes';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

import {
    QUICK_CHECKOUT_DEFAULT_METHOD,
    RECENT_PDP_URL,
} from 'features/quickCheckout/constants/quickCheckout';

import type {QuickCheckoutStateType} from './quickTypes';

export const defaultState = {
    method: [QUICK_CHECKOUT_DEFAULT_METHOD],
    isLoading: false,
    [RECENT_PDP_URL]: sessionStore.get(RECENT_PDP_URL, ''),
};

export const {
    checkout: {recoverQuote, saveRecentUrl},
} = createActions({
    CHECKOUT: {
        /**
         * Cancels apple pay quick checkout
         */
        CANCEL_APPLE_PAY_QUICK_CHECKOUT: () => {},

        /**
         * Recovers previous quote
         * @returns {AxiosPromise} response
         */
        RECOVER_QUOTE: (): AxiosPromise<> =>
            instanceGusaBackend({
                method: 'GET',
                url: ENDPOINTS.QUOTE_RECOVER,
            }),

        /**
         * Saves the recent product's URL to use it for redirection on the checkout page
         * @param {string} url - URL of the last visited PDP
         * @returns {string} redirection URL
         */
        SAVE_RECENT_URL: (url: string): string => url,
    },
});

/**
 * Quick Checkout Reducer
 * @type {ReduxReducer<QuickCheckoutStateType, ActionType<string | void>>}
 */
export const quickCheckout: ReduxReducer<
    QuickCheckoutStateType,
    ActionType<string | void>,
> = handleActions(
    {
        /**
         * Sets the recent product's URL
         * @param {QuickCheckoutStateType} state - current state
         * @returns {QuickCheckoutStateType} new state
         */
        [saveRecentUrl]: (
            state: QuickCheckoutStateType,
            {payload}: ActionType<string>,
        ): QuickCheckoutStateType => ({
            ...state,
            [RECENT_PDP_URL]: payload,
        }),
    },
    defaultState,
);
